export const WHATSAPP_URL = "https://wa.me/393442755343";
export const WHATSAPP_NUMBER_DISPLAY = "+39 344 275 5343";
export const INSTAGRAM_URL = "https://www.instagram.com/autotrasportibennici";
export const INSTAGRAM_HANDLE = "@autotrasportibennici";
export const COMPANY = "AUTOTRASPORTI BENNICI CANICATTÌ";
export const CITY = "Canicattì";
export const SLOGAN =
  "Trasporti e Logistica — Affidabilità, puntualità e sicurezza al tuo servizio";

export const CONTACTS = [
  {
    name: "Costel Bennici",
    phone: "+39 344 275 5343",
    tel: "+393442755343",
    whatsapp: "https://wa.me/393442755343",
  },
  {
    name: "Fabio Bennici",
    phone: "+39 347 956 1786",
    tel: "+393479561786",
    whatsapp: "https://wa.me/393479561786",
  },
];

export const EMAIL = "autotrasportibennici2025@pec.it";
